export const oddscheckerTheme = `
  --body-bg-color: #f4f4f4;
  --header-bg-golor: #03334b;
  --odd-cell-bg-color-highlighted: #0edd98;
  --odd-cell-color-highlighted: #20242e;
`;
